import axios from "axios";
import { TTP_API_URL } from "../config";
import {
  generateCancellationTokenSource,
  getRequestCancellationToken,
  getRequestConfig,
  throwCatchedError,
} from "../utils";

let getNewsletterThemesCTS;

export const getSubscriptionDetails = async (cmail) => {
  const requestUrl = `${TTP_API_URL}/mailing/subscription/details`;

  try {
    const params = {
      cmail: cmail,
    };
    let requestConfig = getRequestConfig(params);

    const response = await axios.get(requestUrl, requestConfig);

    return response.data;
  } catch (error) {
    console.error("Error fetching subscription details:", error);
    throw error;
  }
};

export const updateSubscription = (data) => {
  const requestUrl = `${TTP_API_URL}/mailing/toggle/subscription`;

  var formData = new FormData();
  formData.append("cmail", data.cmail);
  formData.append("subscriberId", data.id);
  formData.append("type", data.type);

  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const updateSubscriptionTT = (data) => {
  const requestUrl = `${TTP_API_URL}/mailing/toggle/subscriptionForTT`;

  var formData = new FormData();
  formData.append("cmail", data.cmail);
  formData.append("subscriberId", data.id);
  formData.append("type", data.type);
  formData.append("unsubscibedFromTT", 1);

  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const getNewsletterThemes = ({
  token,
  clientId,
  search,
  limit,
  offset,
}) => {
  let cancellationTokenSource = generateCancellationTokenSource();
  let requestCancellationToken = getRequestCancellationToken(
    getNewsletterThemesCTS,
    cancellationTokenSource
  );
  getNewsletterThemesCTS = cancellationTokenSource;

  const requestUrl = `${TTP_API_URL}/mailing/theme`;

  let filter = [];

  filter.push({
    property: "type",
    value: "TEMPLATE",
    operator: "eq",
  });

  filter.push({
    property: "actif",
    value: 1,
    operator: "eq",
  });

  filter.push({
    property: "organization",
    value: clientId,
    operator: "eq",
  });

  if (search) {
    filter.push({
      property: "name",
      value: search,
      operator: "like",
    });
  }

  let sort = [{ property: "updatedAt", dir: "desc" }];

  let params = {
    access_token: token,
    fields: "id,name,language,type,isPublic,themeObject",
    filter: JSON.stringify(filter),
    sort: JSON.stringify(sort),
    organization_id: clientId,
  };

  if (limit) {
    params.limit = limit;
    params.start = offset ?? 0;
  } else {
    params.nolimit = 1;
  }

  let requestConfig = getRequestConfig(params, requestCancellationToken);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};
